// M27 T10b: school type (dim.School.kinderkategorie). Pure rules, no React, no fetch.
// The four values and the map of legacy names mirror functions/intranet/src/lib/schultyp.js (SCHULTYP_MAP) with the SAME names
// as the T8 mirror in modules/it/helpdesk/itLogik.ts, so T13 can merge the two copies. A test reads the server file as text
// and fails when the copies drift.

export const SCHULTYPEN = [
  { value: 'GS', kurz: 'GS', lang: 'Grundschule' },
  { value: 'WFS', kurz: 'WFS', lang: 'Weiterführende Schule' },
  { value: 'Kita', kurz: 'Kita', lang: 'Kita' },
  { value: 'Sonstiges', kurz: 'Sonstiges', lang: 'Sonstiges' },
] as const

export type Schultyp = (typeof SCHULTYPEN)[number]['value']

/** Exact-case map of the four values and the old names (owner k_schultyp_map = a). */
export const SCHULTYP_MAP: Readonly<Record<string, Schultyp>> = Object.freeze({
  KiTa: 'Kita', Hort: 'Kita', Krippe: 'Kita',
  Sonstige: 'Sonstiges',
  GBS: 'GS',
  GS: 'GS', WFS: 'WFS', Kita: 'Kita', Sonstiges: 'Sonstiges',
})

/** School type of a raw value: exact case, no trimming, old names mapped; anything else (also empty) is null = nothing selected. */
export function schultypVon(raw: string | null | undefined): Schultyp | null {
  return typeof raw === 'string' && Object.hasOwn(SCHULTYP_MAP, raw) ? SCHULTYP_MAP[raw] : null
}

/** Text for lists and the editor: "Grundschule (GS)", "Kita"; the old names show the text of their mapped type; unknown text stays as it is. */
export function schultypAnzeige(raw: string | null | undefined): string {
  const typ = schultypVon(raw)
  if (!typ) return raw ?? ''
  const s = SCHULTYPEN.find(x => x.value === typ)!
  return s.lang === s.kurz ? s.lang : `${s.lang} (${s.kurz})`
}

/** Filter of the list "Schultyp zuordnen" (owner t10b_inaktiv = b): the list holds active AND inactive schools without a valid type. */
export const STATUS_FILTER = ['alle', 'aktiv', 'inaktiv'] as const
export type StatusFilter = (typeof STATUS_FILTER)[number]

const ERROR_CODES = ['UNGUELTIG', 'NICHT_GEFUNDEN', 'NICHT_VERFUEGBAR', 'MIGRATION_FEHLT']

/** i18n key (namespace schulen) for an error of schulen-schultyp, by the `code` of the server body. */
export function schultypErrorKey(error: unknown): string {
  if (error && typeof error === 'object') {
    const { code, status } = error as { code?: unknown; status?: unknown }
    if (typeof code === 'string' && ERROR_CODES.includes(code)) return `schultyp.errors.${code}`
    if (status === 401) return 'schultyp.errors.session'
    if (status === 403) return 'schultyp.errors.permission'
  }
  return 'schultyp.errors.failed'
}
